export default {
  namespaced: true,
  state: () => ({
    current_space: {}
  }),
  mutations: {
    setCurrentSpace(state, space) { 
      state.current_space = space;
    },
    setCurrentPreviewUrl(state, url) {
      state.current_space.previewUrl = url;
    }
  },
  actions: {
    setCurrentSpace({commit}, space) {
      commit('setCurrentSpace', space);
    },
    setCurrentPreviewUrl({ commit }, url) {
      commit('setCurrentPreviewUrl', url);
    }
  }
}